const ADDRESSES = [
  '100 Main St, Springfield, IL 62704',
  '101 Maple Ave, Oakville, CA 94562',
  '102 Oak Ln, Rivertown, TX 75001',
  '103 Pine Rd, Lakeside, FL 33101',
  '104 Cedar Dr, Mountainview, CO 80202',
  '105 Elm St, Centerville, OH 45459',
  '106 Birch Blvd, Fairview, OR 97024',
  '107 Walnut Ct, Georgetown, SC 29440',
  '108 Spruce Way, Springfield, IL 62704',
  '109 Ash Dr, Oakville, CA 94562',
  '110 Hickory St, Rivertown, TX 75001',
  '111 Willow Ln, Lakeside, FL 33101',
  '112 Poplar Ave, Mountainview, CO 80202',
  '113 Cherry Rd, Centerville, OH 45459',
  '114 Dogwood Dr, Fairview, OR 97024',
  '115 Magnolia Blvd, Georgetown, SC 29440',
  '116 Sycamore Ct, Springfield, IL 62704',
  '117 Redwood Way, Oakville, CA 94562',
  '118 Sequoia Dr, Rivertown, TX 75001',
  '119 Palm St, Lakeside, FL 33101',
  '120 Pine Ave, Mountainview, CO 80202',
  '121 Oak Dr, Centerville, OH 45459',
  '122 Maple Ln, Fairview, OR 97024',
  '123 Cedar Rd, Georgetown, SC 29440',
  '124 Elm Way, Springfield, IL 62704',
  '125 Birch St, Oakville, CA 94562',
  '126 Walnut Blvd, Rivertown, TX 75001',
  '127 Spruce Dr, Lakeside, FL 33101',
  '128 Ash Ct, Mountainview, CO 80202',
  '129 Hickory Rd, Centerville, OH 45459',
  '130 Willow Ave, Fairview, OR 97024',
  '131 Poplar Dr, Georgetown, SC 29440',
  '132 Cherry Ln, Springfield, IL 62704',
  '133 Dogwood St, Oakville, CA 94562',
  '134 Magnolia Rd, Rivertown, TX 75001',
  '135 Sycamore Way, Lakeside, FL 33101',
  '136 Redwood Dr, Mountainview, CO 80202',
  '137 Sequoia Ct, Centerville, OH 45459',
  '138 Palm Ln, Fairview, OR 97024',
  '139 Pine Dr, Georgetown, SC 29440',
  '140 Oak Blvd, Springfield, IL 62704',
  '141 Maple St, Oakville, CA 94562',
  '142 Cedar Ave, Rivertown, TX 75001',
  '143 Elm Ct, Lakeside, FL 33101',
  '144 Birch Rd, Mountainview, CO 80202',
  '145 Walnut Dr, Centerville, OH 45459',
  '146 Spruce Blvd, Fairview, OR 97024',
  '147 Ash Ln, Georgetown, SC 29440',
  '148 Hickory St, Springfield, IL 62704',
  '149 Willow Ct, Oakville, CA 94562',
  '150 Poplar Way, Rivertown, TX 75001',
  '151 Cherry Dr, Lakeside, FL 33101',
  '152 Dogwood Ave, Mountainview, CO 80202',
  '153 Magnolia Ln, Centerville, OH 45459',
  '154 Sycamore Rd, Fairview, OR 97024',
  '155 Redwood St, Georgetown, SC 29440',
  '156 Sequoia Way, Springfield, IL 62704',
  '157 Palm Dr, Oakville, CA 94562',
  '158 Pine Ct, Rivertown, TX 75001',
  '159 Oak Rd, Lakeside, FL 33101',
  '160 Maple Dr, Mountainview, CO 80202',
  '161 Cedar Blvd, Centerville, OH 45459',
  '162 Elm Ln, Fairview, OR 97024',
  '163 Birch St, Georgetown, SC 29440',
  '164 Walnut Ave, Springfield, IL 62704',
  '165 Spruce Rd, Oakville, CA 94562',
  '166 Ash Way, Rivertown, TX 75001',
  '167 Hickory Ct, Lakeside, FL 33101',
  '168 Willow Dr, Mountainview, CO 80202',
  '169 Poplar St, Centerville, OH 45459',
  '170 Cherry Blvd, Fairview, OR 97024',
  '171 Dogwood Ln, Georgetown, SC 29440',
  '172 Magnolia Dr, Springfield, IL 62704',
  '173 Sycamore St, Oakville, CA 94562',
  '174 Redwood Ct, Rivertown, TX 75001',
  '175 Sequoia Rd, Lakeside, FL 33101',
  '176 Palm Dr, Mountainview, CO 80202',
  '177 Pine Way, Centerville, OH 45459',
  '178 Oak Ln, Fairview, OR 97024',
  '179 Maple St, Georgetown, SC 29440',
  '180 Cedar Dr, Springfield, IL 62704',
  '181 Elm Way, Oakville, CA 94562',
  '182 Birch Ct, Rivertown, TX 75001',
  '183 Walnut Ln, Lakeside, FL 33101',
  '184 Spruce Rd, Mountainview, CO 80202',
  '185 Ash Blvd, Centerville, OH 45459',
  '186 Hickory St, Fairview, OR 97024',
  '187 Willow Dr, Georgetown, SC 29440',
  '188 Poplar Way, Springfield, IL 62704',
  '189 Cherry Ct, Oakville, CA 94562',
  '190 Dogwood Rd, Rivertown, TX 75001',
  '191 Magnolia St, Lakeside, FL 33101',
  '192 Sycamore Ave, Mountainview, CO 80202',
  '193 Redwood Dr, Centerville, OH 45459',
  '194 Sequoia Ln, Fairview, OR 97024',
  '195 Palm Rd, Georgetown, SC 29440',
  '196 Pine St, Springfield, IL 62704',
  '197 Oak Way, Oakville, CA 94562',
  '198 Maple Ct, Rivertown, TX 75001',
  '199 Cedar Dr, Lakeside, FL 33101',
];

export default ADDRESSES;
